import React, { createContext, useContext, useState } from 'react';
import { IFilterState, ITableState } from 'taltech-styleguide';


export type PaginationState = {
  page: number;
  sizePerPage: number;
  total: number;
};

export type SortState = {
  sortField?: string;
  sortOrder?: "asc" | "desc";
};

export type FilterState = {
  filters?: { [dataField: string]: IFilterState };
};

export type QueryState = PaginationState & SortState & FilterState;

export type TableState = {
  isLoading: boolean;
  query: QueryState;
  total: number;
  items: any[];
  handleTableChange: (type: string, state: ITableState) => void;
  refetch: () => void;
};


export interface TableContextProps {
  query: QueryState;
  isLoading: boolean;
  total: number;
  items: any[];
}

// Create the context
export const TableContext = createContext<TableState | undefined>(undefined);

// Custom hook to use the context
export const useTableContext = () => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context;
};
